import { Injectable } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject, filter } from 'rxjs';
import { Breadcrumb } from './breadcrumb';
import { SignalsService } from '@shared/services/signals/signals.service';

@Injectable({
  providedIn: 'root'
})
export class BreadcrumbService {

  private breadcrumbSubject = new BehaviorSubject<Breadcrumb[]>([]);
  breadcrumbs$ = this.breadcrumbSubject.asObservable();

  private navigationHistory: Breadcrumb[] = [];

  constructor(
    private router: Router, 
    private route: ActivatedRoute,
    private signalService: SignalsService
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      this.updateBreadcrumbs();
    });
  }

  
  /**
   * Updates the breadcrumb navigation trail based on the current navigation history.
   * If the current URL is '/sequence', removes any 'Flight' labeled items from history.
   * Prevents duplicate breadcrumbs by checking URLs before adding new items.
   * Emits the updated breadcrumb array through breadcrumbSubject.
   */
  private updateBreadcrumbs() {
    const breadcrumbs: Breadcrumb[] = [{ url: '/', icon: 'pi pi-home'}];
    
    for (const historyItem of this.navigationHistory) {

      // Remove 'Flight' breadcrumb when navigating to '/sequence'
      if (historyItem.url === '/sequence') {
        this.navigationHistory = this.navigationHistory.filter(crumb => crumb.label !== 'Flight');
      }

      // Prevent duplicate breadcrumbs
      const duplicateExists = breadcrumbs.find(crumb => crumb.url === historyItem.url);
      if (!duplicateExists) {
        breadcrumbs.push(historyItem);
      }
    }
    this.breadcrumbSubject.next(breadcrumbs);
  }

  /**
   * Adds a new breadcrumb to the navigation history.
   * Called from each component's ngOnInit() method where a breadcrumb is desired.
   * @param url The URL of the breadcrumb.
   * @param label The label of the breadcrumb.
   * */
  addToBreadcrumbs(url: string, label: string) {
    
    const containsBreadcrumb = this.navigationHistory.find(crumb => {
      crumb.url === url && crumb.label === label}
    );
    if (!containsBreadcrumb) {
      this.navigationHistory.push({ url, label });
    }
    this.updateBreadcrumbs();
  }

  /** Clear breadcrumb when navigating to another nav menu item */
  clearBreadcrumbs() {
    this.navigationHistory = [];
    //this.breadcrumbSubject.next([]);
  }

  removeBreadcrumb(labels: string[]) {
    for (const label of labels) {
      this.navigationHistory = this.navigationHistory.filter(b => b.label !== label);
    }
    this.updateBreadcrumbs();
  }

  removeAllPastThisLabel(label: string) {
    const index = this.navigationHistory.findIndex(b => b.label === label);
    this.navigationHistory = this.navigationHistory.slice(0, index + 1);
    this.updateBreadcrumbs();
  }
}
